module.exports = __webpack_public_path__ + "static/img/index-title-icon.cd229d48.png";